import reminders from './modules/store'

export const modules = {
  reminders
}



// WEBPACK FOOTER //
// ./src/store/Reminders/index.js